import React from 'react';
import './OrderProgress.css';

const ORDER_STEPS = [
  { key: 'placed', label: 'Placed' },
  { key: 'processing', label: 'Processing' },
  { key: 'shipped', label: 'Shipped' },
  { key: 'delivered', label: 'Delivered' },
];

const getStepIndex = (status) => {
  switch (status.toLowerCase()) {
    case 'placed': return 0;
    case 'processing': return 1;
    case 'shipped': return 2;
    case 'delivered': return 3;
    default: return 0;
  }
};

const OrderProgress = ({ status }) => {
  const currentStep = getStepIndex(status);
  return (
    <div className="order-progress">
      {ORDER_STEPS.map((step, idx) => (
        <div key={step.key} className={`order-step${idx <= currentStep ? ' active' : ''}${idx < currentStep ? ' completed' : ''}`}> 
          <div className="order-step-circle">{idx + 1}</div>
          <div className="order-step-label">{step.label}</div>
          {idx < ORDER_STEPS.length - 1 && <div className="order-step-line" />}
        </div>
      ))}
    </div>
  );
};

export default OrderProgress; 